export enum LayoutViewType {
  Desktop = 'desktop',
  Tablet = 'tablet',
  Mobile = 'mobile',
}
